/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48686Item {
  
  /** task_id */
  taskId?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** 任务描述 */
  taskDesc?: string;
  
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  
  /** 计划完成时间 */
  endTime?: any;
  
  /** 权限 ,ProjectTaskAuthResp */
  authorizationResp?: any;
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 执行人列表 ,WorkTaskExecutorResult */
  taskExecutorList?: API48686Item[];
  
  /** 计划开始时间 */
  startTime?: any;
  
  /** 计划完成时间 */
  endTime2?: any;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** kr编号 */
  okrKrNo?: string;
  
  /** okr-o编号 */
  okrONo?: string;
  
  /** okr进度，默认0 */
  okrProcess?: any;
  
  /**  */
  okrProcessDesc?: string;
  
};
    
  



export interface API48686Req {
  
  /**  */
  TASK_STATUS_OVER_DUE?: string;
    
  /** 项目编号 */
  projectNo?: string;
    
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成10.逾期),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: string;
    
  /** 执行人id */
  executorId?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API48686Res {
  /** T  */
  list?: API48686Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48686 任务分页查询

export interface IUseGetAPI48686Return {
  /** 任务分页查询: 接口请求状态 */
  isAPI48686Loading: boolean;
  /** 任务分页查询: 接口请求返回数据 */
  dataAPI48686: API48686Res;
  /**  任务分页查询: 接口数据请求方法 */
  fetchAPI48686Data:  (inputs: API48686Req, config?: YWRequestConfig) => Promise<API48686Res>;
  /** 任务分页查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48686 = ():IUseGetAPI48686Return => {
  let isMount = true;
  const [isAPI48686Loading, setIsAPI48686Loading] = useState(false);
  const [dataAPI48686, setDataAPI48686] = useState<API48686Res>({} as API48686Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/page`;

  const fetchAPI48686Data = async (inputs: API48686Req, config?: YWRequestConfig): Promise<API48686Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48686Req>) || {}) as API48686Req;
    
  
    if ( isMount ) {
      setIsAPI48686Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48686Res>(`${basePath}/corp-admin/project/plan/task/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48686(res || {} as API48686Res);
        setIsAPI48686Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48686Loading(false);
      }
      return false as unknown as API48686Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48686Loading,
    dataAPI48686,
    fetchAPI48686Data,
    requestUrl,
  }
}

